import React from "react";
import "./Header.css";

export const PageHeader = ({ className = "", style, children }) => {
  return (
    <header className={`ko-page-header ${className}`.trim()} style={style}>
      {children}
    </header>
  );
};

export const SectionHeader = ({ className = "", styles, children }) => {
  return (
    <header className={`ko-section-header ${className}`.trim()} style={styles}>
      {children}
    </header>
  );
};
